import React, { PropsWithChildren } from 'react';
import { IconType } from 'react-icons';
import { VariantProps } from 'tailwind-variants';
import { fabStyles } from '../styles';

interface IFabItemProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof fabStyles.item> {
  direction?: 'top' | 'right' | 'left' | 'bottom';
  onClick: () => void;
  open: boolean;
  openMode?: 'hover' | 'click';
  option: {
    disabled?: boolean;
    icon: IconType;
    label: string;
    onClick: () => void;
  };
}

export function FabItem({
  direction = 'top',
  index,
  onClick,
  open,
  openMode,
  option,
}: PropsWithChildren<IFabItemProps>) {
  return (
    <button
      className={fabStyles.item({
        openMode,
        open,
        index,
        disabled: option.disabled,
      })}
      key={option.label}
      onClick={onClick}
    >
      <span className="relative only:-mx-6 ">
        <option.icon className="w-6 h-6" />
      </span>
      {/* Tooltip */}
      <div
        className={fabStyles.tooltip({
          openMode,
          open,
          direction,
        })}
      >
        {option.label}
      </div>
    </button>
  );
}
